import type { OpportunityListType } from "../../types";

import { BASE_OPPORTUNITY_LIST_URL } from "./const";

export const createStaticListUrl = (listId: OpportunityListType["opportunityListId"], path?: string): string =>
    `${BASE_OPPORTUNITY_LIST_URL}/${listId}${path ?? ""}`;
